import { GetChatsForm, GetChatsResponse } from '../../interfaces/api/qna';
import { api } from '../api';
import http from '../http';
import { BaseApiResponse } from '../../interfaces/api/baseApiResponse';

/**
 * Chat management services
 * Provides methods for retrieving, managing, and manipulating chat history
 */
export const chats = {
  /**
   * Retrieves a list of chats with optional filtering
   * @param {GetChatsForm} [body] - Optional parameters for filtering chats
   * @returns {Promise<GetChatsResponse>} Promise resolving to chat list response
   */
  getChats: (body?: GetChatsForm): Promise<GetChatsResponse> =>
    new Promise((resolve, reject) => {
      const url = `${api.qna.chats}?length=${body?.length || 50}&start=${body?.start || 0}&search=${body?.search || ''}&is_favorite=${body?.favourite || 0}&tab_id=${body?.tab_id || ''}&date=${Number(new Date())}`;
      http
        .get(url)
        .then((res) => resolve(res as GetChatsResponse))
        .catch((e) => reject(e));
    }),

  /**
   * Toggles the favorite status of a chat
   * @param {number} chatId - ID of the chat to update
   * @param {boolean} [inFavorite=false] - Whether to set as favorite or not
   * @param {string} [tab_id] - Optional tab ID for filtering
   * @returns {Promise<BaseApiResponse>} Promise resolving to the API response
   */
  setFavorite: (chatId: number, inFavorite: boolean = false, tab_id?: string): Promise<BaseApiResponse> =>
    new Promise((resolve, reject) => {
      const url = `${api.qna.toggleFavorite}/${chatId}?date=${Number(new Date())}&tab_id=${tab_id || ''}`;
      http
        .post(url, {
          in_favorite: inFavorite,
        })
        .then((res) => resolve(res as GetChatsResponse))
        .catch((e) => reject(e));
    }),

  /**
   * Deletes a chat from history
   * @param {number} chatId - ID of the chat to remove
   * @returns {Promise<BaseApiResponse>} Promise resolving to the API response
   */
  removeChat: (chatId: number): Promise<BaseApiResponse> =>
    new Promise((resolve, reject) => {
      const url = `${api.qna.removeChat}/${chatId}`;
      http
        .post(url, {})
        .then((res) => resolve(res as GetChatsResponse))
        .catch((e) => reject(e));
    }),
};
